// extracted by mini-css-extract-plugin
export var link = "_uf-0";